import React from 'react'
import second from './img/mycv.jpg'

function Mycv() {
  return (
    <div>
    <img className='cv' style={{textAlign: 'center'}}  src={second} alt="" />
    </div>
  )
}

export default Mycv